import numeral from 'numeral';
import React from 'react';
import { Link } from 'react-router';
import { IconButton } from 'material-ui';
import Checkbox from 'material-ui/Checkbox';

import moment from 'moment';

import utils from '../../misc/utils';
var config = utils.getConfig();

export default (fieldName, cell, format, entity, updateEntityCallBack) => {
  let handleCheckboxChanged = (e, isInputChecked) => {
    entity[fieldName] = isInputChecked;
    if(updateEntityCallBack)
      updateEntityCallBack(entity);
  }

  if (format.calculation) {
    cell = eval(format.calculation);
  }

  switch (format && format.type) {
    case 'link':
      return <Link style={ { color: 'black' } } to={ `${format.url}` }>{ cell }</Link>;
    case 'button':
      return (
        <div>
          <IconButton
            label={ `${format.text}` }
            onClick={() => format.action(entity)}
            children={format.content}
          />
          {cell && <span style={{marginLeft: '5px', verticalAlign: 'text-bottom'}}>{format.displayColumn ? eval(format.displayColumn) : cell}</span>}
        </div>
      );
    case 'date':
      return new Date(cell).toISOString().slice(0,10);
    case 'datetime':
      return (cell ? moment(cell).utc().format('YYYY-MM-DD HH:mm') : '');
    case 'percentage':
      return `${numeral(cell).format('0.0')}%`;
    case 'money':
      return `$${numeral(cell).format('0,0.00')}`;
    case 'relation':
      if(cell)
        return cell[format.displayColumn];
      else
        return '';
    case 'image':
      if(cell)
        return (<img src={config.webApiUrl + 'api/images/' + cell} style={{width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle'}}/>);
      else
        return '';
    default:
      var output = '';
      if(typeof cell === 'boolean' || format.type === 'boolean'){
        if(format.inlineEdit) {
          return (
            <Checkbox
              style={{textAlign: 'right'}}
              onCheck={(event, isInputChecked) => handleCheckboxChanged(event, isInputChecked)}
              checked={cell ? cell : false}/>
          );
        }
        else {
          if(cell)
            output = 'oui';
          else
            output = 'non';
        }
      }
      else if(cell)
        output = cell.toString();

      return output;
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/SmartTable/formatTableCell.js
 **/